import { ToEntity } from 'core/common/mappers';
import { User } from 'core/user/entities/User';
import { UserDto } from 'core/user/services/dto';

export class UserDtoMapper implements ToEntity<User, UserDto> {
  toEntity(dto: UserDto): User {
    return {
      id: dto.id,
      userId: dto.user_id,
      email: dto.email,
      utmParams: dto.utm_params,
      quizData: dto.quiz_data,
      country: dto.country,
      settings: dto.settings,
      region: dto.region,
      funnelName: dto.funnel_name,
      locale: dto.locale,
    };
  }
}
